import { Component, OnInit } from '@angular/core';
import { ModalController, PopoverController } from '@ionic/angular';

@Component({
  selector: 'app-videomodal',
  templateUrl: './videomodal.page.html',
  styleUrls: ['./videomodal.page.scss'],
})
export class VideomodalPage implements OnInit {
  videoplayer_name:any;

  constructor(
    public modalCtrl: ModalController,
    public popoverCtrl: PopoverController,
  ) { }

  ngOnInit() {
    console.log("tom")
  }

  ionViewWillEnter() {
    console.log(this.videoplayer_name)
  }
  addVideoClose(){
    this.modalCtrl.dismiss({
      dismissed: true, 
    });
  }
}
